"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';
import '../../../../lib/propsContext/propsContext.mjs';
import 'react';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../../../lib/componentFactory/flowComponent.mjs';
import styles from '../../ContextMenu.module.scss.mjs';
import { getAriaSelectionMode, getMenuItemSelectionVariant, getCloseOverlayType } from '../../lib.mjs';
import { Action } from '../../../Action/Action.mjs';

const ContextMenuSection = flowComponent(
  "ContextMenuSection",
  (props) => {
    const { children, selectionMode, ref, ...rest } = props;
    const selectionVariant = getMenuItemSelectionVariant(selectionMode);
    const propsContext = {
      Heading: {
        level: 5,
        wrapWith: /* @__PURE__ */ jsx(Aria.Header, {})
      },
      MenuItem: {
        selectionVariant
      }
    };
    return /* @__PURE__ */ jsx(
      Aria.MenuSection,
      {
        ref,
        ...rest,
        selectionMode: getAriaSelectionMode(selectionMode),
        className: styles.section,
        children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children: /* @__PURE__ */ jsx(Action, { skip: true, children: /* @__PURE__ */ jsx(Action, { closeOverlay: getCloseOverlayType(selectionMode), children }) }) })
      }
    );
  }
);

export { ContextMenuSection, ContextMenuSection as default };
//# sourceMappingURL=ContextMenuSection.mjs.map
